RivalIQ.apps.Alerts.module('collections', function (collections, App, Backbone, Marionette, $, _, moment) {
    'use strict';

    const Alerts = collections.Alerts = Backbone.Collection.extend({
        getUrlParams: function () {

            const me = this;
            return _.extend({
                startDate: moment.utc(me.startDate).format('YYYY-MM-DD'),
                endDate: moment.utc(me.endDate).format('YYYY-MM-DD')
            }, _.pick(me, 'landscapeId', 'limit', 'class'));
        },
        getUrlQueryString: function () {

            const me = this;
            const params = me.getUrlParams();
            return RivalIQ.utils.url.param(params);
        }
    });

    const CompanyAlerts = Alerts.extend({
        url: function () {

            const me = this;
            const url = `/api/landscapes/${me.landscapeId}/companies/${me.companyId}/events`;
            return [url, me.getUrlQueryString()].join('?');
        }
    });

    const LandscapeAlerts = Alerts.extend({
        url: function () {

            const me = this;
            const url = `/api/landscape/${me.landscapeId}/events`;
            return [url, me.getUrlQueryString()].join('?');
        },
        getUrlParams: function () {

            const me = this;
            return _.extend({
                companySetDescriptor: me.companySetDescriptor,
                focusCompanyId: me.companyId
            }, CompanyAlerts.prototype.getUrlParams.apply(me, arguments));
        }
    });

    const RecentLandscapeAlerts = LandscapeAlerts.extend({
        url: function () {

            const me = this;
            const url = `/api/landscape/${me.landscapeId}/events/recent`;
            return [url, me.getUrlQueryString()].join('?');
        },
        getUrlParams: function () {

            const me = this;
            return _.extend({
                limit: me.limit
            }, _.omit(LandscapeAlerts.prototype.getUrlParams.apply(me, arguments), 'startDate', 'endDate'));
        }
    });

    /**
     * Creates an alerts collection for a company.
     * @param companyId
     * @param landscapeId
     * @param startDate
     * @param endDate
     */
    Alerts.createForCompany = function (companyId, landscapeId, startDate, endDate) {
        return _.extend(new CompanyAlerts(), {
            companyId: companyId,
            landscapeId: landscapeId,
            startDate: startDate,
            endDate: endDate
        });
    };

    /**
     * Creates an alerts collection for a landscape.
     * @param landscapeId
     * @param startDate
     * @param endDate
     */
    Alerts.createForLandscape = function (props) {

        return _.extend(new LandscapeAlerts(), _.pick(props,
            'landscapeId', 'startDate', 'endDate', 'companySetDescriptor', 'limit', 'class'));
    };

    /**
     * Creates a recent alerts collection for a landscape.
     * @param landscapeId
     * @param limit
     */
    Alerts.createForLandscapeRecent = function (props) {
        const attrs = _.pick(props, 'limit', 'landscapeId', 'companySetDescriptor');
        attrs.companyId = props.focusCompanyId;
        return _.extend(new RecentLandscapeAlerts(), attrs);
    };

    /**
     * Creates an alerts collection from options.
     * @param options
     */
    Alerts.createFromOptions = function (options) {
        options = options || {};
        const companyId = parseInt(options.companyId);
        const landscapeId = parseInt(options.landscapeId);

        if (!isNaN(companyId)) {
            return Alerts.createForCompany(companyId, landscapeId, options.startDate, options.endDate);
        } else {
            return Alerts.createForLandscape(options);
        }
    };

}, window.moment);
